'use strict';
angular.module('manageProSiteModule', [
    'mangeProSiteServiceModule',
    'productManageMentWebsiteSiteRouterModule',
])
    .controller('manageProSiteController', ['$scope', '$rootScope', '$modal', '$timeout', '$location', '$state', '$stateParams', '$q', 'trsHttpService', 'localStorageService', 'modalDialog', 'productMangageMentWebsiteService', 'permissionService', 'websiteService', 'previewToolService', 'sortOfSitesService', 'trsspliceString',
        function ($scope, $rootScope, $modal, $timeout, $location, $state, $stateParams, $q, trsHttpService, localStorageService, modalDialog, productMangageMentWebsiteService, permissionService, websiteService, previewToolService, sortOfSitesService, trsspliceString) {
            initStatus();
            initData();

            /**
             * [getSiteRights description]获取每个站点的操作权限
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.getSiteRights = function (item) {
                productMangageMentWebsiteService.getRight(item.SITEID, '', 'websetsite.site').then(function (data) {
                    $scope.status.rights[item.SITEID] = data;
                });
            };
            // 获取站点操作权限结束
            $scope.addViews = function () {
                saveSite('新建站点', '', $scope.status.data.sites);
            };

            /**
             * [clickSiteDirected description]点击站点重定向开始
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.clickSiteDirected = function (item) {

                /* $stateParams.site = item.SITEID;
                $state.transitionTo($state.current, $stateParams, {
                    reload: false
                });*/
                if (!$scope.status.rights[item.SITEID].site.edit) {
                    return;
                } else {
                    $scope.modifyViews(item);
                }

                // 根据需求将页面跳转改为弹框
                // productMangageMentWebsiteService.getChannelAccessAuthority(item.SITEID).then(
                //     function(data) {
                //         //將权限信息存入缓存，用于底部路由区加载使用开始
                //         localStorageService.remove("rightOperType_site"); //初始化缓存
                //         localStorageService.set("rightOperType_site", {
                //             type: data.router,
                //             data: data.data
                //         });
                //         //將权限信息存入缓存，用于底部路由区加载使用结束
                //         $state.go("manageconfig.productmanage.website." + data.router, { site: item.SITEID, status: item.STATUS }, { reload: true });
                //     }
                // );
            };
            $scope.modifyViews = function (item) {
                var modParams = {
                    serviceid: 'mlf_websiteconfig',
                    methodname: 'findWebSiteById',
                    SiteId: item.SITEID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), modParams, 'post')
                    .then(function (data) {
                        var siteInfo = {
                            ObjectId: item.SITEID,
                            repeatUseTime: data.REPEATUSETIME,
                            SiteName: data.SITEDESC,
                            SiteDesc: data.SITEDESC,
                            DataPath: data.DATAPATH,
                            SiteOrder: data.SITEORDER,
                            RootDoMain: data.ROOTDOMAIN,
                            CheckFgdAttribute: parseInt(data.CHECKFGDATTRIBUTE),
                            Ispaichong: parseInt(data.ISPAICHONG),
                            ISORIGINAL: data.ISORIGINAL,
                            temp: {},
                            otherTemp: {},
                            xilanTemp: {},
                            CKMSIMDAYRANGE: isNaN(data.CKMSIMDAYRANGE) ? 0 : Number(data.CKMSIMDAYRANGE), // 稿件排重时间范围
                        };
                        // 编辑时默认绑定模板数据转换开始
                        siteInfo.temp.TEMPID = angular.isDefined(data.GAILANTEMP[0]) ? data.GAILANTEMP[0].TEMPID : '0';
                        siteInfo.otherTemp.TEMPID = angular.isDefined(data.OTHERTEMP[0]) ? data.OTHERTEMP[0].TEMPID : '0';
                        siteInfo.xilanTemp.TEMPID = angular.isDefined(data.DOCTEMP[0]) ? data.DOCTEMP[0].TEMPID : '0';
                        siteInfo.temp.TEMPNAME = angular.isDefined(data.GAILANTEMP[0]) ? data.GAILANTEMP[0].TEMPNAME : '';
                        siteInfo.otherTemp.TEMPNAME = angular.isDefined(data.OTHERTEMP[0]) ? data.OTHERTEMP[0].TEMPNAME : '';
                        siteInfo.xilanTemp.TEMPNAME = angular.isDefined(data.DOCTEMP[0]) ? data.DOCTEMP[0].TEMPNAME : '';
                        siteInfo.siteId = $stateParams.site;
                        // 编辑时默认绑定模板数据转换结束
                        saveSite('修改站点', siteInfo, $scope.status.data.sites);
                    });
            };

            // 预览站点
            $scope.preview = function (item) {
                previewToolService.sitePreview(item);
            };

            /**
             * [enableDisable description]启用停用站点
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.enableDisable = function (item) {
                if (item.STATUS === '0') {
                    $scope.disableSite(item);
                } else {
                    $scope.reductionViews(item);
                }
            };

            /**
             * [reductionViews description]启用站点
             *
             * @param   {[type]}  item  [item description]站点信息
             *
             * @return  {[type]}        [return description]
             */
            $scope.reductionViews = function (item) {
                modalDialog.alertType('确定启用该站点？', '', 'ask', true, function (data) {
                    var reSiteParams = {
                        serviceid: 'mlf_websiteconfig',
                        methodname: 'restoreSites',
                        ObjectIds: item.SITEID,
                        RestoreAll: false,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), reSiteParams, 'post')
                        .then(function (data) {
                            $timeout(function () {
                                modalDialog.alertType('启用成功', '', 'success', false);
                            }, 1000);
                            requestData();
                        });
                });
            };

            /**
             * [disableSite description]停用站点
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.disableSite = function (item) {
                var checkParams = {
                    serviceid: 'mlf_websiteconfig',
                    methodname: 'deleteWebsiteCondition',
                    SiteId: item.SITEID,
                };
                var deleteParams = {
                    serviceid: 'mlf_websiteconfig',
                    methodname: 'deleteSite',
                    SiteId: item.SITEID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), checkParams, 'get')
                    .then(function (data) {
                        modalDialog.inputModel('停用', '停用原因（选填）', function (data) {
                            productMangageMentWebsiteService.inputPassword(function (password) {
                                LazyLoad.js(['./lib/js-base64/base64.js',], function () {
                                    deleteParams.PassWord = '__encoded__' + Base64.encode(angular.copy(password));
                                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), deleteParams, 'get')
                                        .then(function (data) {
                                            modalDialog.alertType('停用成功', '', 'success', false);
                                            $state.go($state.current.name, $stateParams, { reload: true, });
                                        });
                                });
                            });
                        });
                    });
            };

            /**
             * [deleteSite description]删除站点
             *
             * @param   {[type]}  item  [item description]站点信息
             *
             * @return  {[type]}        [return description]
             */
            $scope.deleteSite = function (item) {
                $scope.selectChannelIds = trsspliceString.spliceString(item, 'SITEID', ',');
                var ckConditionParamas = {
                    serviceid: 'mlf_websiteconfig',
                    methodname: 'checkWebsiteCondition',
                    SiteIds: $scope.selectChannelIds,
                };
                var deleteParams = {
                    serviceid: 'mlf_websiteconfig',
                    methodname: 'RemoveSites',
                    SiteIds: $scope.selectChannelIds,
                    PassWord: '',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), ckConditionParamas, 'get')
                    .then(function (data) {
                        productMangageMentWebsiteService.inputPassword(function (password) {
                            LazyLoad.js(['./lib/js-base64/base64.js',], function () {
                                deleteParams.PassWord = '__encoded__' + Base64.encode(angular.copy(password));
                                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), deleteParams, 'get')
                                    .then(function (data) {
                                        modalDialog.alertType('删除成功', '', 'success', false);
                                        $state.go($state.current.name, $stateParams, { reload: true, });
                                    });
                            });
                        });
                    });
            };

            /**
             * [batDelete description] 批量删除站点
             * @return {[type]} [description]
             */
            $scope.batDelete = function () {
                if ($scope.status.selectedArray.length == 0) {
                    modalDialog.alertType('请先选择一个站点', '', 'warning', false);
                    return;
                } else {
                    modalDialog.alertType('确定要删除选中的站点吗', '', 'warning', true, function () {
                        $scope.deleteSite($scope.status.selectedArray);
                    });
                }
            };

            $scope.search = function (ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    $scope.status.params.SiteDesc = $scope.searchWord;

                    /* $state.transitionTo($state.current, $stateParams, {
                        reload: false
                    });*/
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.params, 'post').then(
                        function (data) {
                            localStorageService.set('manageconfig.website.sites', data);
                            $scope.status.data.sites = data.DATA;

                            /* $state.transitionTo($state.current, $stateParams, {
                                reload: true
                            });*/
                        });
                }
            };

            /**
             * [initStatus description]初始化数据
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.page = {
                    ITEMCOUNT: 0,
                    PAGESIZE: 20,
                    CURRPAGE: 1,
                    PAGECOUNT: 0,
                    copyCurrPage: 1,
                };
                $scope.status = {
                    routerPath: $location.path().split('/'),
                    data: {
                        sites: '',
                        selectedSite: '',
                    },
                    params: {
                        'serviceid': 'mlf_websiteconfig',
                        'methodname': 'queryWebSitesForCloud',
                        'SiteDesc': $stateParams.sitedesc,
                        // 'PageSize': $scope.page.PAGESIZE,
                        // 'PageIndex': $scope.page.CURRPAGE
                    },
                    statusOptions: [{
                        name: '全部状态',
                    }, {
                        name: '启用',
                        value: 0,
                    }, {
                        name: '停用',
                        value: -1,
                    }, ],
                    selectedArray: [],
                    rights: {},
                    publishOptions: [{ name: '仅发布首页', value: 0, }, { name: '全站发布', value: 1, }, ],
                };
                $scope.status.selectStatus = $scope.status.statusOptions[0],
                permissionService.isTenantAdministrator().then(function (data) {
                    $scope.status.isTenantAdministrator = data; // 是否是系统管理员
                });
            }

            /**
             * [pageChanged description]翻页功能
             *
             * @return  {[type]}  [return description]
             */
            $scope.pageChanged = function () {
                $scope.page.copyCurrPage = $scope.page.CURRPAGE;
                $scope.status.params.PageIndex = $scope.page.CURRPAGE;
                requestData();
            };

            /**
             * [selectPageNum description]选择单页数据条数
             *
             * @return  {[type]}  [return description]
             */
            $scope.selectPageNum = function () {
                $scope.status.params.PageSize = $scope.page.PAGESIZE;
                requestData();
            };

            /**
             * [jumpToPage description]跳转到第几页
             *
             * @return  {[type]}  [return description]
             */
            $scope.jumpToPage = function () {
                $scope.page.CURRPAGE = $scope.page.copyCurrPage;
                $scope.status.params.PageIndex = $scope.page.CURRPAGE;
                requestData();
            };

            /**
             * [selectAll description] 选中全部站点
             * @return {[type]} [description]
             */
            $scope.selectAll = function () {
                $scope.status.selectedArray = $scope.status.selectedArray.length == $scope.status.data.sites.length ? [] : [].concat($scope.status.data.sites);
            };

            /**
             * [selectSite description]选中某个站点
             *
             * @param   {[type]}  site  [site description]栏目数据
             *
             * @return  {[type]}        [return description]
             */
            $scope.selectSite = function (site) {
                if ($scope.status.selectedArray.indexOf(site) < 0) {
                    $scope.status.selectedArray.push(site);
                } else {
                    $scope.status.selectedArray.splice($scope.status.selectedArray.indexOf(site), 1);
                }
            };

            /**
             * [selectStatus description]根据状态筛选站点
             *
             * @return  {[type]}  [return description]
             */
            $scope.selectStatus = function () {
                $scope.status.params.status = $scope.status.selectStatus.value;
                requestData();
            };

            /**
             * [initData description]初始化方法
             *
             * @return  {[type]}  [return description]
             */
            function initData() {
                requestData().then(function (data) {
                    $scope.status.data.selectedSite = getSiteById($scope.status.data.sites, $location.search().site);
                    // 切换站点广播开始
                    $scope.$emit('changeSiteToParent', $scope.status.data.selectedSite);
                    $scope.searchWord = $stateParams.sitedesc;
                });
            }

            /**
             * [getSiteById description]获得站点
             *
             * @param   {[type]}  sites   [sites description]
             * @param   {[type]}  siteid  [siteid description]
             *
             * @return  {[type]}          [return description]
             */
            function getSiteById(sites, siteid) {
                if (angular.isDefined(sites)) {
                    for (var i = 0; i < sites.length; i++) {
                        if (sites[i].SITEID == siteid) {return sites[i];}
                    }
                }
            }

            /**
             * [requestData description]数据
             *
             * @return  {[type]}  [return description]
             */
            function requestData() {
                var deferred = $q.defer();
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.params, 'get').then(function (data) {
                    $scope.status.data.sites = data.DATA;
                    $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                    $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
                    $state.transitionTo($state.current, $stateParams, {
                        reload: false,
                    });
                    deferred.resolve(data);
                });
                return deferred.promise;
            }

            /**
             * [saveSite description]保存站点
             *
             * @param   {[type]}  title     [title description]
             * @param   {[type]}  siteInfo  [siteInfo description]
             * @param   {[type]}  allSite   [allSite description]
             *
             * @return  {[type]}            [return description]
             */
            function saveSite(title, siteInfo, allSite) {
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/productManageMent/website/site/template/website_modify_tpl.html',
                    windowClass: 'productManageMent-website-modify-view',
                    backdrop: false,
                    controller: 'mangeProSiteModCtrl',
                    resolve: {
                        params: function () {
                            return {
                                title: title,
                                siteInfo: siteInfo,
                                allSite: allSite,
                            };
                        },
                    },
                });
                modalInstance.result.then(function (newsite) {
                    newsite.serviceid = 'mlf_websiteconfig';
                    newsite.methodname = 'saveNewSite';
                    newsite.SiteDesc = newsite.SiteDesc;
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), newsite, 'post').then(function (data) {
                        modalDialog.alertType('保存成功', '', 'success', false);
                        $state.go($state.current.name, $stateParams, { reload: 'manageconfig.productmanage', });
                    }, function () {
                        $state.go($state.current.name, $stateParams, { reload: 'manageconfig.productmanage', });
                    });
                });
            }
            $scope.selectPublishWay = function () {
                delete $scope.status.publishWay;
            };

            /**
             * [publish description]批量发布站点
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.publish = function (item) { // 22
                $scope.status.selectedPublishWay = item.value;
                if ($scope.status.selectedArray.length !== 1) {
                    modalDialog.alertType('请选择一个站点', '', 'warning', false);
                    return;
                }
                $timeout(function () {
                    if ($scope.status.selectedPublishWay === 0) {$scope.publishHome($scope.status.selectedArray[0]);} else {$scope.publishFull($scope.status.selectedArray[0]);}
                });
            };

            /**
             * [singlePublish description] 单个站点发布
             * @param {[object]} [site] [description] 站点信息
             * @return {[type]} [description]
             */
            $scope.singlePublish = function (site) {
                $timeout(function () {
                    if ($scope.status.selectedPublishWay.value === 0) {$scope.publishHome(site);} else {$scope.publishFull(site);}
                });
            };

            /**
             * [sortOfSites description] 站点排序
             * @return {[type]} [description]
             */
            $scope.sortOfSites = function () {
                if ($scope.status.selectedArray.length !== 1) {
                    modalDialog.alertType('请选择一个站点', '', 'warning', false);
                    return;
                }
                var index = $scope.status.data.sites.indexOf($scope.status.selectedArray[0]) + 1;
                sortOfSitesService.sorts('website', index, $scope.status.selectedArray[0], $scope.status.data.sites, function (data) {
                    if (data.ISSUCCESS == 'true') {
                        $state.go($state.current.name, $stateParams, { reload: true, });
                    }
                });

            };

            // 发布到首页
            $scope.publishHome = function (item) {
                if (!$scope.status.rights[item.SITEID].site.solopublish) {
                    modalDialog.alertType('您没有这个站点的仅发布首页权限', '', 'warning', 'confirm');
                    return;
                }
                modalDialog.alertType('确认发布该站点首页吗？', '', 'ask', true, function (data) {
                    websiteService.websitePublish(item.SITEID, '103');
                });
            };
            // 全部发布
            $scope.publishFull = function (item) {
                if (!$scope.status.rights[item.SITEID].site.publish) {
                    modalDialog.alertType('您没有这个站点的全站发布权限', '', 'warning', 'confirm');
                    return;
                }
                modalDialog.alertType('确认要全站发布吗？', '', 'ask', true, function (data) {
                    var publishParams = {
                        serviceid: 'mlf_publish',
                        methodname: 'fullyPublish',
                        ObjectIds: item.SITEID,
                        ObjectType: '103',
                    };
                    // 2020-01-15将post请求更改为get请求
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), publishParams, 'get').then(
                        function (data) {
                            modalDialog.alertType('发布成功', '', 'success', false);
                        });
                });
            };

            $scope.openDrop = function () {

            };
        },
    ]);
